/**
 * Adapters between ActivityForm's Activity v2 body shape (camelCase,
 * sent to api-activity-v2-service today) and the transcript's
 * captured-item payload shape (snake_case, matches what the Python
 * agent emits and what Go's SaveSection fan-out reads on Save & next).
 *
 * Same pattern as complaintBodyAdapters / diagnosisBodyAdapters /
 * medicineBodyAdapters / hospitalisationBodyAdapters /
 * labInvestigationBodyAdapters / allergyBodyAdapters /
 * familyHistoryBodyAdapters / addictionBodyAdapters.
 *
 *   Activity v2 body      → captured "add" payload
 *   {name, category, catalogId, daysPerWeek, minutesPerSession,
 *    intensity, status, description}
 *      →
 *   {name, category, catalog_id, days_per_week, minutes_per_session,
 *    intensity, status, description, value}
 */

/**
 * Activity v2 body → captured "add" payload.
 */
export function bodyToCapturedAdd(body) {
  const name = (body.name || "").trim();
  return {
    name,
    category:            body.category || "",
    catalog_id:          body.catalogId || "",
    days_per_week:       Number(body.daysPerWeek) || 0,
    minutes_per_session: Number(body.minutesPerSession) || 0,
    intensity:           body.intensity || "moderate",
    status:              body.status || "active",
    description:         body.description || "",
    value:               name,
  };
}

/**
 * Stub — Wave B first-cut doesn't route Activity updates via AI.
 * Symmetric with the other section adapters.
 */
export function bodyToCapturedUpdate(body /* , context */) {
  return bodyToCapturedAdd(body);
}
